import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconUser: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="user, people, person, member"><path d="M15.6006 12.3564C18.2098 13.6742 20 16.3772 20 19.5V20.25C20 20.6642 19.6642 21 19.25 21H4.75C4.33579 21 4 20.6642 4 20.25V19.5C4 16.3775 5.78962 13.6743 8.39844 12.3564C9.41664 13.0759 10.6585 13.5 12 13.5C13.3413 13.5 14.5825 13.0756 15.6006 12.3564Z" fill="currentColor"/><path d="M12 2.5C14.6234 2.5 16.75 4.62665 16.75 7.25C16.75 9.87335 14.6234 12 12 12C9.37665 12 7.25 9.87335 7.25 7.25C7.25 4.62665 9.37665 2.5 12 2.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconUser;
